import * as React from 'react';
import { useMemo } from 'react';
import { useAtom } from 'jotai';
import { useTranslation } from 'next-i18next';

import { Heading, Modal, ModalContent } from '@restworld/ui-ds-base';

import { notificationModalStateAtom, notificationModalToggleAtom } from './save-research-tab.atoms';
import SavedResearchNotificationModalFooter from './saved-research-modal-footer';
import SavedResearchNotificationModalContent from './saved-research-modal-content';
import { useSavedResearchProps } from './save-research-tab.hooks';

const SavedResearchNotificationChangeModal = () => {
  const [notificationModalToggle, setNotificationModalToggle] = useAtom(notificationModalToggleAtom);
  const [notificationModalState] = useAtom(notificationModalStateAtom);
  const { title } = useSavedResearchProps();

  const { t } = useTranslation('user-settings');

  const modalTitle = useMemo(
    () =>
      notificationModalState === null ? (
        title
      ) : notificationModalState === 'unsubscribe_user_review' ? (
        <Heading className="text-start lg:text-center text-[24px] lg:text-[30px] px-5 leading-[28.8px] lg:leading-[39px]">
          {t('explain_why_you_no_longer_want_offer_updates')}
        </Heading>
      ) : (
        ``
      ),
    [notificationModalState, t, title]
  );

  return (
    <Modal open={notificationModalToggle} onOpenChange={(v) => !v && setNotificationModalToggle(false)}>
      <ModalContent title={modalTitle} footer={<SavedResearchNotificationModalFooter />} className="lg:w-[31.75rem]">
        <SavedResearchNotificationModalContent />
      </ModalContent>
    </Modal>
  );
};
export default SavedResearchNotificationChangeModal;
